import { useState } from "react";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React examples
import DataTable from "examples/Tables/DataTableForTop10";

// Data

import { Progress } from "rsuite";
import { Grid } from "@mui/material";
import { TabPanel, TabView } from "primereact/tabview";
import Top10RejectionReportsCardData from "./top10Rejection";
import Top10MinMaxFailureReportsCardData from "./top10MinMaxFailure";
import Top10RTVReportsCardData from "./top10RTV";
import Top10TOReportsCardData from "./top10TO";

function Top10ReportsCard() {
  return (
    <Card sx={{ height: "355px", overflow: "auto" }}>
      <MDBox pt={2} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <MDBox p={2} mb={-2} mt={-2}>
              <MDTypography variant="h6" gutterBottom>
                Top 10 Reports
              </MDTypography>
            </MDBox>

            {/* {picklistTrackingModule && groupedpicklistModule ? ( */}

            <TabView>
              <TabPanel header="Rejection">
                <Top10RejectionReportsCardData />
              </TabPanel>

              <TabPanel header="Picklist Failure">
                <Top10MinMaxFailureReportsCardData />
              </TabPanel>
              <TabPanel header="RTV">
                <Top10RTVReportsCardData />
              </TabPanel>
              <TabPanel header="TO">
                <Top10TOReportsCardData />
              </TabPanel>
            </TabView>

            {/* ) : !picklistTrackingModule && groupedpicklistModule ? (
             
             <TabView>
                <TabPanel header="Grouped By Picklist">
                  <GroupedPicklistTracking />
                </TabPanel>
              </TabView>

            ) : picklistTrackingModule && !groupedpicklistModule ? (
              
              <TabView>
                <TabPanel header="Picklist Tracking">
                  <PicklistTracking />
                </TabPanel>
              </TabView>
              
            ) : (
              <>
                <h4 style={{ textAlign: "center", marginTop: "6rem" }}>
                  No PickList Access
                </h4>
              </>
            )} */}
          </Grid>
        </Grid>
      </MDBox>
    </Card>
  );
}

export default Top10ReportsCard;
